<template>
  <v-dialog v-model="fullScreen" fullscreen>
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <div v-bind="attrs" v-on="{ ...dialog, ...tooltip }">
            <ExpandIcon />
          </div>
        </template>
        <span>{{$t('fullScreenInput.tooltip')}}</span>
      </v-tooltip>
    </template>
    <v-card>
      <div class="fullScreenCard">
        <div></div>
        <div class="textContainer">
          <div class="fs-back" @click="closeDialog">
            <BackArrowIcon />
            <div class="fs-back-text">{{$t('fullScreenInput.back')}}</div>
          </div>
          <div
            v-if="!isPageShow"
            class="fs-textInput"
            id="textInput"
            name="textInput"
            :contenteditable="readOnly"
          >
            {{ text }}
          </div>
          <div v-else
            class="fs-textInput"
            id="textInput"
            name="textInput"
            :contenteditable="readOnly">
            {{textArr[page]}}
          </div>
          <div  v-if="isPageShow" class="fs-pagesBtnWrapper">
             <v-tooltip left>
              <template v-slot:activator="{ on: tooltip }">
                          <v-btn icon class="fs-pageBtn" @click="minusPage" v-on="tooltip"><ArrowLeftIcon color="white"/></v-btn>

              </template>
              <span>Өмнөх хэсэг </span>
             </v-tooltip>
                          <v-tooltip right>
              <template v-slot:activator="{ on: tooltip }">
                          <v-btn icon class="fs-pageBtn" @click="plusPage" v-on="tooltip"><ArrowLeftIcon color="white" style="transform:rotate(180deg)"/></v-btn>

              </template>
              <span>Дараагийн хэсэг </span>
             </v-tooltip>
        </div>
        </div>
        <div @click="closeDialog"><ShrinkIcon /></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ExpandIcon from "../components/icons/ExpandIcon";
import ShrinkIcon from "../components/icons/ShrinkIcon";
import BackArrowIcon from "../components/icons/BackArrowIcon";
import ArrowLeftIcon from "../components/icons/ArrowLeftIcon"
export default {
  name: "FullScreenInput",
  components: {
    ExpandIcon,
    BackArrowIcon,
    ShrinkIcon,
    ArrowLeftIcon
  },
  data: () => ({
    text: "",
    fullScreen: false,
    page: 0,
    textArr:[],
    isPageShow:false,
  }),
  props: {
    inputText: { type: String },
    textArray: Array,
    isShow: Boolean,
    currentPage: Number,
    readOnly: { type: Boolean, default: false },
    onClose: { type: Function },
  },
  created(){
    
  },
  watch: {
    fullScreen: function() {
      if (this.fullScreen && !this.readOnly) {
        this.text = this.inputText;
      }
      if(this.fullScreen){
        this.page = this.currentPage;
        this.textArr = this.textArray;
        this.isPageShow = this.isShow;
      }
    },
  },
  mounted() {
    this.text = this.inputText;
  },
  methods: {
    closeDialog() {
      this.fullScreen = false;
      if (!this.readOnly) {
        this.onClose(this.text);
      }
    },
        plusPage(){
      if(this.page < this.textArray.length-1){
        this.page++;
      }
    },
    minusPage(){

      if(this.page != 0){
        this.page--;
      }
    }
  },
};
</script>
<style>
.fullScreenCard {
  display: flex;
  justify-content: space-between;
  padding: 10px !important;
}
.textContainer {
    display: flex;
  flex-direction: column;
  width: 70%;
  height: calc(100vh - 120px);
}

.fs-textInput {

  height: calc(100% - 50px);
  width: 100%;
  margin: 13px 0px;
  /* background-color: red; */
}
.fs-back {
  display: flex;
  margin: 5px 0px;
}
.fs-back-text {
  color: #767676;
  font-weight: bold;
  margin-left: 8px;
}

.fs-pageBtn {
  display: flex;
  border-radius: 7px;
  background-color: #777ff6;
  height: 24px !important;
  width: 24px !important;
  transition: all 0.3s;
}

.fs-pagesBtnWrapper {
  display: flex;
  width: 54px;
  justify-content: space-between;
  align-self: flex-end;
  margin-right: 10px;
}
</style>
